import { isEmailShaped } from "../../../domain/email-shape";

// ── bulk-import-email: the ONE email predicate used by parse + the modal ─────
// Wave 5. Kept as its own tiny module so the parser, the single-add modal, and
// the tests share the exact same validation rule (no drift between client-side
// preview validation and the create form). This mirrors the regex the Wave-4
// participant-form-modal already uses; the server remains authoritative.

export function isValidParticipantEmail(email: string): boolean {
  const trimmed = email.trim();
  if (trimmed.length === 0 || trimmed.length > 320) return false;
  return isEmailShaped(trimmed);
}
